import { convertNumberToCommaSeparatedFormat } from "utils/string";

const getOrCreateTooltip = (chart) => {
  let tooltipElement = chart.canvas.parentNode.querySelector("div");

  if (!tooltipElement) {
    tooltipElement = document.createElement("div");
    tooltipElement.style.background = "white";
    tooltipElement.style.borderRadius = "3px";
    tooltipElement.style.color = "black";
    tooltipElement.style.maxWidth = "max-content";
    tooltipElement.style.width = "100%";
    tooltipElement.style.boxShadow =
      "0px 6px 10px -4px rgba(0, 0, 0, 0.15), 0px 2px 2px rgba(40, 40, 40, 0.1)";
    tooltipElement.style.opacity = 1;
    tooltipElement.style.pointerEvents = "none";
    tooltipElement.style.position = "absolute";
    tooltipElement.style.transform = "translate(-80%, 0)";
    tooltipElement.style.transition = "all .1s ease";
    tooltipElement.style.zIndex = 1;

    const table = document.createElement("table");
    table.style.margin = "0px";
    table.style.width = "100%"; // Set the table to 100% width

    tooltipElement.appendChild(table);
    chart.canvas.parentNode.appendChild(tooltipElement);
  }

  return tooltipElement;
};

export const patientComplianceAnalyticTooltipHandler = (context) => {
  const { chart, tooltip } = context;
  const month = tooltip.dataPoints?.[0]?.label;
  const dataPoints = context.tooltip.dataPoints;

  // Create ToolTip
  const tooltipElement = getOrCreateTooltip(chart);

  if (!month || tooltip.opacity === 0) {
    tooltipElement.style.opacity = 0;
    return;
  }

  if (tooltip?.body && tooltip?.body?.length > 0) {
    const table = tooltipElement.querySelector("table");
    table.style.width = "100%";

    const firstRow = document.createElement("tr");
    const tableHeader = document.createElement("th");
    tableHeader.setAttribute("colspan", "3");
    tableHeader.style.fontSize = "14px";
    tableHeader.style.fontWeight = 600;
    tableHeader.style.textAlign = "left";
    tableHeader.textContent = `${month} - Count (Transmission)`;

    firstRow.appendChild(tableHeader);

    const tableBody = document.createElement("tbody");

    dataPoints?.forEach(
      ({ dataIndex, dataset: { backgroundColor, data, label } }) => {
        // Get Data Count
        const rowElement = document.createElement("tr");

        const ColumnLegend = document.createElement("td");
        const ColumnLabel = document.createElement("td");
        ColumnLabel.style.paddingRight = "10px";
        const ColumnValue = document.createElement("td");

        ColumnValue.style.paddingRight = "20px";
        const count = data?.[dataIndex] || 0;
        const span = document.createElement("span");

        span.style.background = backgroundColor;
        span.style.borderWidth = "2px";
        span.style.borderRadius = "50%";
        span.style.marginRight = "5px";
        span.style.width = "10px";
        span.style.height = "10px";
        span.style.display = "inline-block";

        ColumnLegend.append(span);
        ColumnLabel.textContent = label;
        ColumnValue.textContent = `${convertNumberToCommaSeparatedFormat(
          count
        )}${label === "Met Expectation" ? "%" : ""}`;

        rowElement.appendChild(ColumnLegend);
        rowElement.appendChild(ColumnLabel);
        rowElement.appendChild(ColumnValue);
        rowElement.style.marginRight = "10px";
        tableBody.append(rowElement);
      }
    );

    table.append(firstRow);
    table.append(tableBody);

    while (table.firstChild) {
      table.firstChild.remove();
    }

    // Add new children
    table.appendChild(firstRow);
    table.appendChild(tableBody);
  }

  const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;

  // Adjust tooltip position to be slightly left of the bar chart
  tooltipElement.style.opacity = 1;
  tooltipElement.style.left = positionX + tooltip.caretX + 91 + "px"; // Adjust -20 for slight left position
  tooltipElement.style.top = positionY + tooltip.caretY - 90 + "px";
  tooltipElement.style.font = tooltip.options.bodyFont.string;
  tooltipElement.style.padding =
    tooltip.options.padding + "px " + tooltip.options.padding + "px";
};
